<div class="addressable-dashboard">
    <main-custom-dashboard *ngIf="selected && graphList[selected]" [dashboard]="selected"
        [graphList]="graphList[selected]">
    </main-custom-dashboard>
</div>